import { render, staticRenderFns } from "./BsaFooter.vue?vue&type=template&id=ab2fd740"
import script from "./BsaFooter.vue?vue&type=script&lang=js"
export * from "./BsaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab2fd740')) {
      api.createRecord('ab2fd740', component.options)
    } else {
      api.reload('ab2fd740', component.options)
    }
    module.hot.accept("./BsaFooter.vue?vue&type=template&id=ab2fd740", function () {
      api.rerender('ab2fd740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/bsa/BsaFooter.vue"
export default component.exports